import { render, staticRenderFns } from "./MaterialsView.vue?vue&type=template&id=3048aa3e&scoped=true&"
import script from "./MaterialsView.vue?vue&type=script&lang=js&"
export * from "./MaterialsView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3048aa3e",
  null
  
)

export default component.exports